class UniGlossario extends HTMLElement {
  constructor() {
    super();

    this.searchInput = null;
    this.letterButtons = [];
    this.groups = [];
    this.items = [];
    this.searchDebounceTimer = null;
  }

  connectedCallback() {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.searchInput = this.querySelector('[data-uni-glossario-search]');
    this.letterButtons = Array.from(this.querySelectorAll('[data-uni-glossario-letter]'));
    this.groups = Array.from(this.querySelectorAll('[data-uni-glossario-group]'));
    this.items = Array.from(this.querySelectorAll('[data-uni-glossario-item]'));

    this.searchInput?.addEventListener('input', this.handleSearchInput.bind(this));

    this.letterButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        if (button.disabled) {
          return;
        }

        const target = document.getElementById(button.getAttribute('aria-controls'));

        target?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    });

    this.updateLetters();
  }

  handleSearchInput() {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => {
      this.handleSearch();
    }, 200);
  }

  handleSearch() {
    const query = this.normalize(this.searchInput?.value || '');

    this.items.forEach((item) => {
      const searchableText = this.normalize(item.dataset.searchTitle || '');
      item.hidden = query !== '' && !searchableText.includes(query);
    });

    this.groups.forEach((group) => {
      const visibleItems = Array.from(group.querySelectorAll('[data-uni-glossario-item]')).some((item) => !item.hidden);
      group.hidden = !visibleItems;
    });

    this.updateLetters();
  }

  updateLetters() {
    this.letterButtons.forEach((button) => {
      const letter = button.dataset.uniGlossarioLetter;
      const group = this.groups.find((item) => item.dataset.uniGlossarioGroup === letter);
      const hasVisibleItems = Boolean(
        group && !group.hidden && Array.from(group.querySelectorAll('[data-uni-glossario-item]')).some((item) => !item.hidden)
      );

      button.disabled = !hasVisibleItems;
      button.setAttribute('aria-disabled', String(!hasVisibleItems));
    });
  }

  normalize(value) {
    return value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }
}

if (!customElements.get('uni-glossario')) {
  customElements.define('uni-glossario', UniGlossario);
}
